import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client';
import { RetryLink } from 'apollo-link-retry';
import { queryInterceptor, mutationInterceptor } from './cache';

const httpLink = new HttpLink({
    //uri: 'https://online-api-gateway.dev.webmail.comhar.local/graphql',
    // uri: 'http://mytt01.eir.ie/graphql',
    // uri: `https://myeir-test02.eir.ie/graphql/`,
    // uri: 'https://myeir-preprod.eir.ie/graphql/',
    uri: `${window.location.origin}/graphql/`,
    credentials: 'include', // Include cookies in requests
});

//Create a custom RetryLink function that retries until success
const retryLink = new RetryLink({
    delay: {
        initial: 1000, // Initial delay in milliseconds between retries
        max: 5000, // Maximum delay in milliseconds between retries
        jitter: true, //Adds jitter to the delays
    },
    attempts: {
        max: 5, //Retry indefinitely untill successs
        retryIf: (error, _operation) => !!error, // Retry on any network error
    },
});

const link = retryLink.concat(httpLink);

export const cache = new InMemoryCache();

const client = new ApolloClient({
    link,
    cache,
    defaultOptions: {
        query: {
            fetchPolicy: 'cache-first',
        },
    },
});

const originalQuery = client.query.bind(client);
client.query = options => originalQuery(queryInterceptor(options));

const originalWatchQuery = client.watchQuery.bind(client);
client.watchQuery = options => originalWatchQuery(queryInterceptor(options));

const originalMutate = client.mutate.bind(client);
client.__AUTO_MUTATION_INVALIDATION__ = true;
client.mutate = async (options = {}) => {
    const result = await originalMutate(options);
    mutationInterceptor(client, options);
    return result;
};

export default client;
